import * as FuncionesServices from "../../utils/funciones-services";

export const obtenerAliasCoberturas = async (productos) => {
    return FuncionesServices.procesarRespuestraCloud({
        url: process.env.REACT_APP_WS_POST_ALIAS_COBERTURA,
        method: 'POST',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'Iam-id-token'              : 'Bearer ' + FuncionesServices.getIamToken(),
            'transactionId'             : FuncionesServices.generarCorrelativo(),
            'correlationId'             : FuncionesServices.generarCorrelativo(),
            'businessProcess'            : process.env.REACT_APP_BUSINESS_PROCESS,
            'applicationName'          : process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser'         : 'test',
            'Content-Type'              : 'application/json'
        }),
        body: JSON.stringify({datos:productos})
    })
}

export const obtenerTextosCoberturas = async (codCobertura) => {
    let atributos = [ {campo: 'codCobertura', valor: codCobertura} ]
    return FuncionesServices.procesarRespuestraCloud({
        url: FuncionesServices.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_TEXTO_COBERTURA, atributos),
        method: 'GET',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'Iam-id-token'              : 'Bearer ' + FuncionesServices.getIamToken(),
            'transactionId'             : FuncionesServices.generarCorrelativo(),
            'correlationId'             : FuncionesServices.generarCorrelativo(),
            'businessProcess'            : process.env.REACT_APP_BUSINESS_PROCESS,
            'applicationName'          : process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser'         : 'test',
            'Content-Type'              : 'application/json',
        })
    })
}